import { render, staticRenderFns } from "./EpisodeDelinkConfirm.vue?vue&type=template&id=97fbe112&scoped=true"
import script from "./EpisodeDelinkConfirm.vue?vue&type=script&lang=ts"
export * from "./EpisodeDelinkConfirm.vue?vue&type=script&lang=ts"
import style0 from "./EpisodeDelinkConfirm.vue?vue&type=style&index=0&id=97fbe112&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97fbe112",
  null
  
)

export default component.exports